module.exports = __webpack_public_path__ + "img/payment.6562acfa.png";